<template>
    <button type="button" class="upgrade-to-premium-button" @click="openPaywall">
        UPGRADE TO PREMIUM
    </button>
</template>

<script>
import lessonRecordAccess from "@/mixins/lesson-record-access";

export default {
    name: "upgrade-to-premium-button",
    mixins: [lessonRecordAccess],
    props: {
        lesson: {
            type: Object,
            default: null,
        },
    },
    methods: {
        openPaywall() {
            this.openLessonRecordPaywall(this.lesson);
        },
    },
};
</script>

<style lang="scss" scoped>
.upgrade-to-premium-button {
    display: block;
    width: 100%;
    height: 52px;
    border: 0;
    border-radius: 100px;
    background: linear-gradient(180deg, $green_0 -51.92%, $green_1 100%);
    color: white;
    font-size: 16px;
    font-weight: 600;
    font-family: canada-type-gibson, sans-serif;
    letter-spacing: 0.02em;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 20px;

    &:focus {
        outline: 0;
    }
}
</style>
